/**
 * Single source of truth for the canonical site URL.
 *
 * INTENTIONALLY HARDCODED to production URL regardless of environment.
 * This is correct behavior for:
 * - Canonical links (search engines need the authoritative URL)
 * - Schema.org JSON-LD (stable identity across environments)
 *
 * Staging/preview environments should still declare prod as canonical
 * to prevent duplicate content indexing. Non-prod indexing is controlled
 * via X-Robots-Tag headers and sitemap disabling, not canonicals.
 *
 * Future enhancement: If staging share previews need environment-aware
 * og:url, add a separate usePublicOrigin() composable for that purpose.
 */

// Canonical site URL - hardcoded to production (see comment above)
const CANONICAL_URL = 'https://www.metwide.com.au'

export function useSiteUrl(): string {
  return CANONICAL_URL
}

/**
 * Server-side helper for use in Nitro middleware/routes.
 * Import from '~~/app/composables/useSiteUrl' in server code.
 */
export const SITE_URL = CANONICAL_URL
